import Vue from "vue";
import Vuex from "vuex";

import indices from "@/store/indices.store";
import objects from "@/store/objects.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    indices,
    objects
  },
  state: {},
  mutations: {},
  actions: {}
});
